import React from 'react';

import { bemCssModules, getTestId } from '@utils';

import style from './MenuButton.scss';

const cn = bemCssModules(style, 'MenuButton');
const ti = getTestId('MenuButton');

export type TMenuButton = {
  className?: string;
  isOpen?: boolean;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export const MenuButton: React.FC<TMenuButton> = props => {
  const { className, isOpen, ...rest } = props;

  return (
    <button className={cn(null, [className])} data-testid={ti('button')} type="button" {...rest}>
      <div className={cn('wrapper')}>
        <div className={cn('dot1', { active: isOpen })} />
        <div className={cn('line1', { active: isOpen })} />
        <div className={cn('line2', { active: isOpen })} />
        <div className={cn('dot2', { active: isOpen })} />
      </div>
    </button>
  );
};

export default MenuButton;
